import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { AdmissionBatchData } from '../HomePage';

interface Props {
    data: AdmissionBatchData[];
}

function BieuDoTuyenSinh({ data }: Props) {
    return (
        <BarChart
            xAxis={[
                {
                    scaleType: 'band',
                    data: data.map((item) => item.batch),
                    label: 'Đợt tuyển sinh'
                }
            ]}
            series={[
                {
                    data: data.map((item) => item.studentCount),
                    label: 'Số lượng sinh viên',
                    color: '#82ca9d'
                }
            ]}
            width={500}
            height={300}
        />
    );
}

export default BieuDoTuyenSinh;
